<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <vs-divider position="center">{{ $t('sections.customer.section.personalInformation') }}</vs-divider>
          <div class="vx-row flex flex-wrap">
            <!-- Prefix -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.prefix')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.prefix') }}*</label>
                <v-select :clearable="true" :options="prefixOptions" :name="$t('sections.customer.dataForm.prefix')" :reduce="res => res.value" v-model="form.prefix" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- Name -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-2/5">
              <validation-provider :name="$t('sections.customer.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.customer.dataForm.name") }}*</label>
                <vs-input type="text" class="w-full" v-model="form.name" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- Surname -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-2/5">
              <validation-provider :name="$t('sections.customer.dataForm.surname')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.customer.dataForm.surname')}}*</label>
                <vs-input type="text" class="w-full" v-model="form.surname" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.birthDay')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.birthDay') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.birthDay"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.idCardNumber')" rules="required|numberOnly" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.idCardNumber') }}*</label>
                <vs-input type="text" class="w-full"  v-model="form.idCardNumber"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.issueDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.issueDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.issueDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.expDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.expDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.expDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.occupation')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.occupation') }}</label>
                <vs-input type="text" v-model="form.career" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.position')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.position') }}</label>
                <vs-input type="text" v-model="form.position" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.affiliate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.affiliate') }}</label>
                <vs-input type="text" v-model="form.affiliate" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.project')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.project') }}*</label>
                <v-select v-model="form.project" :clearable="true" :options="projectOptions" :name="$t('sections.customer.dataForm.project')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.campus')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.campus') }}*</label>
                <v-select v-model="form.campus" :clearable="true" :options="filteredCampusOptions" :name="$t('sections.customer.dataForm.campus')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.studentCode')" rules="required|numberOnly" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.studentCode') }}*</label>
                <vs-input type="text" v-model="form.studentCode" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap ">
            <div class="vx-col w-full sm:w-1/2 md:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.degree')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.degree') }}*</label>
                <v-select v-model="form.degree" :clearable="true" :options="degreeOptions" :name="$t('sections.customer.dataForm.degree')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full sm:w-1/2 md:w-1/4">
              <validation-provider name="ปีการศึกษา" rules="required|periodTermYear" v-slot="{ errors }">
                <label class="vs-input--label">ปีการศึกษา*</label>
                <vs-input type="text" v-model="form.period" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full md:w-1/2">
              <validation-provider :name="$t('sections.customer.dataForm.curriculum')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.faculty') }}/{{ $t('sections.customer.dataForm.curriculum') }}*</label>
                <v-select v-model="form.curriculum" :clearable="true" :options="facultyCurriculumOptions" :name="$t('sections.customer.dataForm.curriculum')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <vs-divider position="center">{{ $t('sections.customer.section.contactInformation') }}</vs-divider>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.location')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.location') }}</label>
                <vs-input type="text" v-model="form.address.location" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumber" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.moo" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alley" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.road" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="store" v-model="form.address.subDistrict" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="store" v-model="form.address.district" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="store" v-model="form.address.province" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="store" v-model="form.address.zipcode" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.locationDoc')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.locationDoc') }}</label>
                <vs-input type="text" v-model="form.address.locationDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumberDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.mooDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alleyDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.roadDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="storeDoc" v-model="form.address.subDistrictDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="storeDoc" v-model="form.address.districtDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="storeDoc" v-model="form.address.provinceDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="storeDoc" v-model="form.address.zipcodeDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.phone')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.phone') }}</label>
                <vs-input type="text" v-model="form.phone" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.mobile')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.mobile') }}*</label>
                <vs-input type="text" v-model="form.mobile" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.email')" rules="required|email" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.email') }}*</label>
                <vs-input type="text" v-model="form.email" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full flex flex-col sm:flex-row sm:justify-end">
              <vs-button class="btn mt-2 sm:mt-0 sm:ml-4 sm:mr-4 w-full sm:w-auto" @click="submit">{{ $t("sections.customer.dataForm.action.btnSave") }}</vs-button>
              <vs-button class="btn mt-2 sm:mt-0 w-full sm:w-auto" type="border" color="warning" @click="reset">{{ $t("sections.customer.dataForm.action.btnReset") }}</vs-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import { DataStore } from 'vue-thailand-address';
import {IStatus} from "@/constants/interface";

const {mapActions: mapCustomerActions, mapState: mapCustomerFields } = createNamespacedHelpers('Customer')
const {mapActions: mapMasterActions } = createNamespacedHelpers('Master')

export default {
  name : 'CustomerBorrowerAdd',
  props: {
    isExternal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      form:{
        prefix: '',
        name: '',
        surname: '',
        birthDay: '',
        idCardNumber: '',
        issueDate: '',
        expDate: '',
        career: '',
        position: '',
        affiliate: '',
        studentCode: '',
        project: '',
        campus: '',
        degree: '',
        period: '',
        periodTerm: '',
        periodYear: 0,
        curriculum: '',
        address: {
          id: '',
          location: '',
          houseNumber: '',
          moo: '',
          alley: '',
          road: '',
          subDistrict: '',
          district: '',
          province: '',
          zipcode: '',
          locationDoc: '',
          houseNumberDoc: '',
          mooDoc: '',
          alleyDoc: '',
          roadDoc: '',
          subDistrictDoc: '',
          districtDoc: '',
          provinceDoc: '',
          zipcodeDoc: ''
        },
        phone: '',
        mobile: '',
        email: '',
        status: 'Enabled'
      },
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
      store: new DataStore(),
      storeDoc: new DataStore()
    }
  },
  computed: {
    ...mapCustomerFields(['status']),
    ...mapGetters({
      prefixOptions :'Master/prefixOptions',
      projectOptions :'Master/projectOptions',
      campusOptions :'Master/campusOptions',
      degreeOptions :'Master/degreeOptions',
      facultyCurriculumOptions :'Master/facultyCurriculumOptions',
      statusesOptions :'Master/statusesOptions',
    }),
    filteredCampusOptions() {
      // Filter campuses based on selected project
      return this.campusOptions.filter(campus => campus.projectId === this.form.project);
    }
  },
  methods: {
    ...mapCustomerActions(['initializing', 'createBorrower']),
    ...mapMasterActions(['getPrefixOptions', 'getProjectOptions', 'getCampusOptions', 'getDegreeOptions', 'getCurriculumOptions']),
    async loadOptions() {
      const vm = this
      const { getPrefixOptions, getProjectOptions, getCampusOptions, getDegreeOptions, getCurriculumOptions } = vm
      if(vm.prefixOptions.length === 0) await getPrefixOptions()
      if(vm.projectOptions.length === 0) await getProjectOptions()
      if(vm.campusOptions.length === 0) await getCampusOptions()
      if(vm.degreeOptions.length === 0) await getDegreeOptions()
      if(vm.facultyCurriculumOptions.length === 0) await getCurriculumOptions()
    },
    async initData() {
      const vm = this
      const prefixesChoose = vm.prefixOptions.find(res => res.isChoose === true)
      const projectsChoose = vm.projectOptions.find(res => res.isChoose === true)
      const campusesChoose = vm.campusOptions.find(res => res.isChoose === true)
      const degreesChoose = vm.degreeOptions.find(res => res.isChoose === true)
      const curriculumsChoose = vm.facultyCurriculumOptions.find(res => res.isChoose === true)
      vm.form = {
        prefix: (prefixesChoose ? prefixesChoose.value : ''),
        name: '',
        surname: '',
        birthDay: '',
        idCardNumber: '',
        issueDate: '',
        expDate: '',
        career: '',
        position: '',
        affiliate: '',
        studentCode: '',
        project: (projectsChoose ? projectsChoose.value : ''),
        campus: (campusesChoose ? campusesChoose.value : ''),
        degree: (degreesChoose ? degreesChoose.value : ''),
        curriculum: (curriculumsChoose ? curriculumsChoose.value : ''),
        address: {
          id: '',
          location: '',
          houseNumber: '',
          moo: '',
          alley: '',
          road: '',
          subDistrict: '',
          district: '',
          province: '',
          zipcode: '',
          locationDoc: '',
          houseNumberDoc: '',
          mooDoc: '',
          alleyDoc: '',
          roadDoc: '',
          subDistrictDoc: '',
          districtDoc: '',
          provinceDoc: '',
          zipcodeDoc: ''
        },
        phone: '',
        mobile: '',
        email: '',
        status: IStatus.enabled
      }
    },
    async submit () {
      const vm = this
      const { createBorrower } = vm
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        createBorrower({
          form: {
            prefix: {id: vm.form.prefix || ''},
            name: vm.form.name,
            surname: vm.form.surname,
            birthDay: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.birthDay),
            idCardNumber: vm.form.idCardNumber,
            issueDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.issueDate),
            expDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.expDate),
            career: vm.form.career,
            position: vm.form.position,
            affiliate: vm.form.affiliate,
            studentCode: vm.form.studentCode,
            project: {id: vm.form.project || ''},
            campus: {id: vm.form.campus || ''},
            degree: {id: vm.form.degree || ''},
            periodTerm: vm.form.period.split('/')[0].toString(),
            periodYear: parseInt(vm.form.period.split('/')[1]),
            curriculum: {id: vm.form.curriculum || ''},
            address: {
              location: vm.form.address.location,
              houseNumber: vm.form.address.houseNumber,
              moo: vm.form.address.moo,
              alley: vm.form.address.alley,
              road: vm.form.address.road,
              subDistrict: vm.form.address.subDistrict,
              district: vm.form.address.district,
              province: vm.form.address.province,
              zipcode: vm.form.address.zipcode,
              locationDoc: vm.form.address.locationDoc,
              houseNumberDoc: vm.form.address.houseNumberDoc,
              mooDoc: vm.form.address.mooDoc,
              alleyDoc: vm.form.address.alleyDoc,
              roadDoc: vm.form.address.roadDoc,
              subDistrictDoc: vm.form.address.subDistrictDoc,
              districtDoc: vm.form.address.districtDoc,
              provinceDoc: vm.form.address.provinceDoc,
              zipcodeDoc: vm.form.address.zipcodeDoc
            },
            phone: vm.form.phone,
            mobile: vm.form.mobile,
            email: vm.form.email,
            status: vm.form.status,
            isExternal: vm.isExternal
          },
          vm
        }).then((result) => {
          if(result){
            if(vm.isExternal){
              const { dialog } = vm.$vs
              vm.initData()
              dialog({
                type: 'alert',
                color: 'success',
                title: 'สร้างข้อมูลผู้กู้สำเร็จ',
                text: 'รอเจ้าหน้าที่ติดต่อกลับภายใน 24 ชั่วโมง หรือโทรติดต่อสอบถามเพิ่มเติมได้ที่ 062-618-2112',
              })
            }
          }
        })
      })
    },
    reset () {
      const vm = this
      vm.initData()
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
      'form.project': {
        handler(newValue, oldValue) {
          if(oldValue !== ''){
            this.form.campus = null; // Reset campus when project changes
          }
        },
        immediate: true, // Optional: run the watcher immediately
      },
    },
  },
  async created() {
    const vm = this
    const {initializing} = vm
    initializing(true);
    await vm.loadOptions();
    await vm.initData();
    initializing(false);
  },
}
</script>

<style scoped>
.vx-col {
  padding-top: 10px;
}

</style>
